export default {"src":"/_next/static/media/stressMotivation.579094b3.svg","height":587,"width":1048,"blurWidth":0,"blurHeight":0};